import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';
import { WHATSAPP_DEFAULT } from '../mock';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const menuItems = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Products', path: '/products' },
    { name: 'Certifications', path: '/certifications' },
    { name: 'Infrastructure', path: '/infrastructure' },
    { name: 'Export Markets', path: '/export-markets' },
    { name: 'Export Terms', path: '/export-terms' },
    { name: 'Contact Us', path: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img 
              src="https://customer-assets.emergentagent.com/job_b060ace3-0bc6-4db8-bd84-7f92111eacd1/artifacts/g9ds7k43_WhatsApp%20Image%202026-02-03%20at%205.40.27%20PM.jpeg"
              alt="Agro Corp India Logo"
              className="h-16 w-auto object-contain transform group-hover:scale-105 transition-transform duration-300"
              style={{ 
                filter: 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1))'
              }}
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-3 py-2 text-sm font-medium rounded-md transition-all duration-300 ${
                  isActive(item.path)
                    ? 'text-green-700 bg-green-50'
                    : 'text-gray-700 hover:text-green-700 hover:bg-green-50'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* WhatsApp CTA */}
          <div className="hidden lg:block">
            <a href={WHATSAPP_DEFAULT} target="_blank" rel="noopener noreferrer">
              <Button className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-6 py-2 shadow-md hover:shadow-lg transition-all duration-300">
                <MessageCircle className="mr-2 w-4 h-4" />
                Inquire on WhatsApp
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100 transition-colors duration-300"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-4 py-4 space-y-2">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setMobileMenuOpen(false)}
                className={`block px-4 py-3 text-sm font-medium rounded-md transition-all duration-300 ${
                  isActive(item.path)
                    ? 'text-green-700 bg-green-50'
                    : 'text-gray-700 hover:text-green-700 hover:bg-green-50'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <a href={WHATSAPP_DEFAULT} target="_blank" rel="noopener noreferrer" onClick={() => setMobileMenuOpen(false)}>
              <Button className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white mt-4">
                <MessageCircle className="mr-2 w-4 h-4" />
                Inquire on WhatsApp
              </Button>
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
